import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule, MatIconModule } from '@angular/material';
import { DynamicTranslationsModule } from '@lciapps/dynamic-translations';
import { SharedModule, TranslationModule } from '@lciapps/lci-core';
import { translationConfig } from 'src/app/app.config';
import { environment } from 'src/environments/environment';
import { PipesCommonModule } from '../../../pipes/pipes.module';
import { ActivityPanelComponent } from './components/activity-panel/activity-panel.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { RadioGroupComponent } from './components/checkbox/radio-group.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { LciImageOverlay } from './components/lci-image-overlay/lci-image-overlay';
import { MapUtil } from './components/map/map-util';
import { MapComponent } from './components/map/map.component';
import { PopoutComponent } from './components/popout-component/popout.component';
import { RatingComponent } from './components/rating/rating.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { WholeNumberDirective } from './directives/whole-number.directive';
import { CreateService } from './services/create.service';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatIconModule,
    MatChipsModule,
    DynamicTranslationsModule.forRoot(environment, translationConfig),
    PipesCommonModule
  ],
  declarations: [
    ActivityPanelComponent,
    AutocompleteComponent,
    CheckboxComponent,
    StepperComponent,
    MapComponent,
    DropdownComponent,
    RatingComponent,
    PopoutComponent,
    RadioGroupComponent,
    LciImageOverlay,
    WholeNumberDirective
  ],
  exports: [
    ActivityPanelComponent,
    AutocompleteComponent,
    CheckboxComponent,
    StepperComponent,
    MapComponent,
    DropdownComponent,
    RatingComponent,
    PopoutComponent,
    RadioGroupComponent,
    LciImageOverlay,
    WholeNumberDirective
  ],
  providers: [CreateService]
})
export class ActivitiesSharedModule {
  constructor() {
    /**/
  }

  /*tslint:disable*/
  /**
   * Returns providers for the root module only
   * @returns {ModuleWithProviders}
   */
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ActivitiesSharedModule,
      providers: [MapUtil]
    };
  }
}
